import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import { CodiceFiscaleComponent } from './codice-fiscale.component';
@NgModule({
    imports: [CommonModule,
        FormsModule
],
    declarations: [CodiceFiscaleComponent],
    exports: [CodiceFiscaleComponent],
    providers: []
})
export class CodiceFiscaleModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/codice-fiscale/codice-fiscale.module.ts